module.exports = __webpack_public_path__ + "step4_parent_to_child.cdd70242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_parent_to_child.jpg
// module id = 8mUd
// module chunks = 0